import React, { useState, useEffect, useRef } from 'react';
import "../css/surveyStart.css"
import axios from "axios"
import { SURVEYURL } from "../Apiurl"
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import InactiveSUrvey from '../component/InactiveSurvey';
import LoadingStart from '../component/LoadingStart';

const SurveyStart = () => {
    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [timeLeft, setTimeLeft] = useState(0); // Initial timer value
    const [isTimerExpired, setIsTimerExpired] = useState(false);
    const [quiz, setQuiz] = useState([])
    const [userAns, setUserAns] = useState([])
    const [loading, setLoading] = useState(true)
    const navigate = useNavigate()
    const timerRef = useRef(null);
    const progressRef = useRef(null);
    const params = useParams()
    const [surveyActive, setSurveyActive] = useState(true)


    // Calculate timer duration based on question index
    const getTimerDuration = (questionIndex) => {
        let currQuestion = quiz?.survey_questions[currentQuestion]
        let currQues = userAns?.find((item) => item?.question_id == currQuestion?.id)?.time_taken
        if (Number(quiz?.survey_questions[questionIndex]?.time_limit?.split(" ")[0]) - currQues == 0) {
            return 0
        } else if (Number(quiz?.survey_questions[questionIndex]?.time_limit?.split(" ")[0]) - currQues != 0) {
            return Number(quiz?.survey_questions[questionIndex]?.time_limit?.split(" ")[0]) - currQues || Number(quiz?.survey_questions[questionIndex]?.time_limit?.split(" ")[0])
        } else {
            return Number(quiz?.survey_questions[questionIndex]?.time_limit?.split(" ")[0]); // 10s for first, 20s for second, etc.
        }
    };

    const updateUserResult = async () => {
        try {
            const user = JSON.parse(localStorage.getItem("userDetails"))
            let currQuestion = quiz?.survey_questions[currentQuestion]
            let calcTime = Number(currQuestion?.time_limit?.split(" ")[0])

            const { data } = await axios.post(`${SURVEYURL}/user/playing/answer`, {
                user_id: user?.id, survey_id: user?.survey_id, question_id: currQuestion?.id, user_ans: -1, time_taken: calcTime
            })
            if (data?.success) {
                setUserAns(data?.results)
            } else if (!data?.success && data?.inactive) {
                setSurveyActive(false)
                setTimeout(() => {
                    setLoading(false)
                }, 2000)
            }
        } catch (err) {

        }
    }

    const setTimeForEachQuestionAfterEverySecond = async (prevTime) => {
        try {
            const user = JSON.parse(localStorage.getItem("userDetails"))
            let currQuestion = quiz?.survey_questions[currentQuestion]
            let calcTime = Number(currQuestion?.time_limit?.split(" ")[0])
            // console.log(timeLeft)
            if (prevTime != 0 && prevTime > 1) {
                const { data } = await axios.post(`${SURVEYURL}/user/playing/answer`, {
                    user_id: user?.id, survey_id: user?.survey_id, question_id: currQuestion?.id, user_ans: -1, time_taken: calcTime - prevTime
                })
                if (data?.success) {
                    setUserAns(data?.results)
                } else if (!data?.success && data?.inactive) {
                    setSurveyActive(false)
                    setTimeout(() => {
                        setLoading(false)
                    }, 2000)
                }
            }

        } catch (err) {

        }
    }

    // Start the timer when component mounts or question changes
    useEffect(() => {
        if (quiz && quiz?.survey_questions?.length > 0 && !loading) {
            // Reset timer and state when question changes
            const timerDuration = getTimerDuration(currentQuestion);
            setTimeLeft(timerDuration);
            if (timerDuration <= 0) {
                setIsTimerExpired(true);
            } else {
                setIsTimerExpired(false);
            }

            // Clear any existing timer
            if (timerRef.current) {
                clearInterval(timerRef.current);
            }

            // Start a new timer
            timerRef.current = setInterval(() => {
                setTimeLeft((prevTime) => {
                    if (prevTime <= 1) {
                        clearInterval(timerRef.current);
                        setIsTimerExpired(true);
                        updateUserResult()
                     
                        return 0;
                    }
                    if (prevTime > 0) {
                        setTimeForEachQuestionAfterEverySecond(prevTime)
                    }
                    return prevTime - 1;

                });
            }, 1000);

            // Cleanup on unmount or when question changes
            return () => {
                if (timerRef.current) {
                    clearInterval(timerRef.current);
                }
            };
        }

    }, [currentQuestion, quiz?.survey_questions?.length, loading]);

    // Update progress circle
    useEffect(() => {
        if (progressRef.current) {
            const timerDuration = getTimerDuration(currentQuestion);
            if (timerDuration <= 0) {
                progressRef.current.style.background = `conic-gradient(#4CAF50 ${0}%, #e0e0e0 ${0}% 100%)`;
            } else {
                const progress = (timeLeft / timerDuration) * 100;
                progressRef.current.style.background = `conic-gradient(#4CAF50 ${progress}%, #e0e0e0 ${progress}% 100%)`;
            }
        }
    }, [timeLeft, currentQuestion]);
    const extractAudioVideo = (text) => {
        let AVarr = text?.split(".")
        if (AVarr[AVarr?.length - 1] === "mpeg" || AVarr[AVarr?.length - 1] === "mp3") {
            return "audio"
        } else if (AVarr[AVarr?.length - 1] === "mp4" || AVarr[AVarr?.length - 1] === "x-matroska" || AVarr[AVarr?.length - 1] === "mkv") {
            return "video"
        } else {
            return "image"
        }
    }

    const fetchSurveyDetails = async () => {
        try {
            const user = JSON.parse(localStorage.getItem("userDetails"))
            const { data } = await axios.post(`${SURVEYURL}/get-users/playing`, { key: params?.key, user_id: user?.id, survey_id: user?.survey_id })
            if (data?.success) {
                setQuiz(data?.data)
                setUserAns(data?.results?.user_results)
                setTimeout(() => {
                    setLoading(false)
                }, 2000)
            } else {
                if (!data?.status) {
                    setSurveyActive(false)
                    setTimeout(() => {
                        setLoading(false)
                    }, 2000)
                } else {
                    navigate("/survey/thank-you")
                }
            }
        } catch (err) {
            setSurveyActive(false)
            setTimeout(() => {
                setLoading(false)
            }, 2000)
        }
    }
    useEffect(() => {
        if (!params?.key) {
            setSurveyActive(false)
            setTimeout(() => {
                setLoading(false)
            }, 2000)
        } else {
            fetchSurveyDetails()
        }
    }, [params])
    const handleOptionSelect = async (option) => {
        try {
            // Don't allow option selection if timer has expired
            if (isTimerExpired) return;
            if (userAns?.find((item) => item?.user_ans == option?.id)) {
                return
            }
            // setSelectedOption(option);
            // Note: We no longer clear the timer here
            const user = JSON.parse(localStorage.getItem("userDetails"))
            let currQuestion = quiz?.survey_questions[currentQuestion]
            let calcTime = Number(currQuestion?.time_limit?.split(" ")[0]) - timeLeft

            const { data } = await axios.post(`${SURVEYURL}/user/playing/answer`, {
                user_id: user?.id, survey_id: user?.survey_id, question_id: currQuestion?.id, user_ans: option?.id, time_taken: calcTime
            })
            if (data?.success) {
                setUserAns(data?.results)
            } else if (!data?.success && data?.inactive) {
                setSurveyActive(false)
                setTimeout(() => {
                    setLoading(false)
                }, 2000)
            }
        } catch (err) {
            setSurveyActive(false)
            setTimeout(() => {
                setLoading(false)
            }, 2000)
        }

    };

    const handleNextQuestion = async () => {
        // Clear the timer when manually advancing to next question
        if (timerRef.current) {
            clearInterval(timerRef.current);
        }

        if (currentQuestion < quiz?.survey_questions?.length - 1) {
            setCurrentQuestion(prev => prev + 1);
        } else {
            const user = JSON.parse(localStorage.getItem("userDetails"))

            const { data } = await axios.post(`${SURVEYURL}/submit/survey`, { survey_id: user?.survey_id, user_id: user?.id, key: params?.key })
            if (data?.success) {
                localStorage.removeItem("guestUserDetails")
                navigate("/survey/thank-you")
            } else {
                return Swal.fire({
                    text: `${data?.message}`,
                    icon: "warning",
                })
            }
        }
    };

    const handlePreviousQuestion = () => {
        // Clear the timer when manually going back
        if (timerRef.current) {
            clearInterval(timerRef.current);
        }

        if (currentQuestion > 0) {
            setCurrentQuestion(prev => prev - 1);
        }
    };

    const handleSubmitQuiz = async () => {
        try {
            if (timerRef.current) {
                clearInterval(timerRef.current);
            }

            const user = JSON.parse(localStorage.getItem("userDetails"))

            const { data } = await axios.post(`${SURVEYURL}/submit/survey`, { survey_id: user?.survey_id, user_id: user?.id, key: params?.key })
            if (data?.success) {
                navigate("/survey/thank-you")
            } else {
                return Swal.fire({
                    text: `${data?.message}`,
                    icon: "warning",
                })
            }
        } catch (err) {
            setSurveyActive(false)
            setTimeout(() => {
                setLoading(false)
            }, 2000)
        }
    };
    // Calculate grid columns based on number of options
    const getGridColumns = () => {
        const currentQuestionData = quiz?.survey_questions[currentQuestion];
        const optionCount = currentQuestionData.survey_options.length;
        if (optionCount <= 3) return 3; // 3 columns for 3 options
        if (optionCount <= 4) return 2; // 2 columns for 4 options
        if (optionCount <= 6) return 3; // 3 columns for 5-6 options
        return 4; // 4 columns for 7-8 options
    };

    return (
        <div className="question-container">
            {loading ? <LoadingStart /> : !surveyActive ? <InactiveSUrvey /> : <div className="question-card">
                {/* Question Number */}
                <div className="question-number">
                    Question {currentQuestion + 1} of {quiz?.survey_questions?.length}
                </div>

                {/* Timer Circle */}
                <div className="timer-container">
                    <div className="timer-circle" ref={progressRef}>
                        <div className="timer-inner">
                            <span className="timer-value">{timeLeft}</span>
                        </div>
                    </div>
                </div>

                {/* Question */}
                <div className="question-content mt-5" style={{ textAlign: "left" }}>

                    {!isTimerExpired && quiz?.survey_questions[currentQuestion]?.id && <div style={{ textAlign: "left", fontSize: "14px" }} className="question-text my-2 preview" dangerouslySetInnerHTML={{ __html: quiz?.survey_questions[currentQuestion]?.question }} />}

                    {/* Media (if any) */}
                    {!isTimerExpired && quiz?.survey_questions[currentQuestion]?.image && (
                        <div className="question-media">
                            {extractAudioVideo(quiz?.survey_questions[currentQuestion]?.image) === 'image' && (
                                <img
                                    src={quiz?.survey_questions[currentQuestion]?.image}
                                    alt="Question illustration"
                                    className="question-image"
                                />
                            )}
                            {extractAudioVideo(quiz?.survey_questions[currentQuestion]?.image) === 'video' && (
                                <video
                                    src={quiz?.survey_questions[currentQuestion]?.image}
                                    controls
                                    className="question-video"
                                />
                            )}
                            {extractAudioVideo(quiz?.survey_questions[currentQuestion]?.image) === 'audio' && (
                                <audio
                                    src={quiz?.survey_questions[currentQuestion]?.image}
                                    controls
                                    className="question-audio"
                                />
                            )}
                        </div>
                    )}

                    {/* Options */}
                    {!isTimerExpired && <div
                        className="options-container my-2 py-1"
                        style={{
                            gridTemplateColumns: `repeat(${getGridColumns()}, 1fr)`,
                            minHeight: "100px",
                            wordBreak: "break-word"
                        }}
                    >
                        {quiz?.survey_questions[currentQuestion]?.survey_options?.length > 0 && quiz?.survey_questions[currentQuestion]?.survey_options.map((option, index) => (
                            <div
                                key={index}
                                className={`option-item ${userAns?.find((item) => item?.user_ans == option?.id) ? 'selected' : ''} ${isTimerExpired ? 'disabled' : ''}`}
                                onClick={() => handleOptionSelect(option)}
                                style={{ minHeight: "100px", flexWrap: "wrap", color: "black", wordBreak: "break-word" }}
                            >
                                {option?.options}
                                {/* <span className="option-text">{option?.options}</span> */}
                            </div>
                        ))}
                    </div>}
                    {
                        isTimerExpired && <div className='mx-auto text-center my-3'>
                            <img style={{ width: "100px" }} src="https://cdn-icons-png.flaticon.com/512/5757/5757923.png" />
                            <h5 className='my-2'>Question Timeout</h5>
                        </div>
                    }

                    {/* Navigation Buttons */}
                    <div className="navigation-buttons">
                        <div className="left-button">
                            {currentQuestion > 0 && (
                                <button
                                    className="prev-button"
                                    onClick={handlePreviousQuestion}
                                >
                                    Previous Question
                                </button>
                            )}
                        </div>

                        <div className="right-button">
                            {currentQuestion == quiz?.survey_questions?.length - 1 ? (
                                <button
                                    className="submit-button"
                                    onClick={() => {
                                        Swal.fire({
                                            text: "Do You Want to Submit the Survey",
                                            showCancelButton: true,
                                            icon: "warning",
                                        }).then(async (result) => {
                                            if (result.isConfirmed) {
                                                handleSubmitQuiz()
                                            }
                                        })
                                    }}
                                >
                                    Submit Survey
                                </button>
                            ) : (
                                <button
                                    className="next-button"
                                    onClick={handleNextQuestion}
                                >
                                    Next Question
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>}
        </div>
    );
};

export default SurveyStart; 